import { ChangeEvent } from "react";

import { BulkRecalculatePriceSelectionScope } from "@ryde/shared";

export enum BulkRecalculateRateType {
  PriceRate = "priceRate",
  SupplierPriceRate = "supplierPriceRate",
}

export interface IBulkRecalculateSelectionCounts {
  all: number;
  withPriceRate: number;
  withoutPriceRate: number;
  withPriceRateRideIds: number[];
  withoutPriceRateRideIds: number[];
  withClientRateWithoutSupplierRate: number;
  withClientRateWithoutSupplierRateRideIds: number[];
  withSupplierRateWithoutClientRate: number;
  withSupplierRateWithoutClientRateRideIds: number[];
}

export interface IBulkRecalculateSwitchCounts {
  withManualPrice: number;
  withDoneStatus: number;
}

export interface IBulkRecalculateSelectionResult {
  selectionScope: BulkRecalculatePriceSelectionScope;
  onSelectionScopeChange: (event: ChangeEvent<HTMLInputElement>) => void;
  selectionCounts: IBulkRecalculateSelectionCounts;
  switchCounts: IBulkRecalculateSwitchCounts;
  selectedRideIdsForRecalculate: number[];
}

export interface IBulkRecalculateSelectionTranslationKeys {
  allHelperKey: string;
  withRateLabelKey: string;
  withRateHelperKey: string;
  withoutRateLabelKey: string;
  withoutRateHelperKey: string;
}

export interface IBulkRecalculateSelectionRadioOption {
  value: BulkRecalculatePriceSelectionScope;
  label: string;
  helperText: string;
  disabled: boolean;
}
